import { IAppState } from '../../redux';

export function selectOfferGuid(state: IAppState): string {
  return state.offer.objectGuid;
}
